import { CONTRACT_STATUS } from "@constants/Enums";
import { error_message } from "@constants/Errors";

export const validateDates = (
  errorToast,
  setError,
  setDateError,
  contractData,
) => {
  let valid = true;
  contractData.forEach((contract) => {
    if (contract.status === CONTRACT_STATUS.ACTIVE) {
      if (!contract.start_date) {
        errorToast(error_message.tenant.date_not_defined);
        setError(error_message.tenant.date_not_defined);
      }
      if (
        contract.end_date &&
        new Date(contract.start_date) > new Date(contract.end_date)
      ) {
        valid = false;
        errorToast(error_message.tenant.bad_input);
        setError(error_message.tenant.bad_input);
      }
    }
  });
  setDateError(valid);
  return valid;
};
